module.exports = __webpack_public_path__ + "img/1.78b30de5.png";